import { useQuery } from '@tanstack/react-query'
import { ExtendableQueryOptions } from 'shared/api/api.types'

import { forgeApi } from '../..'
import { ArtifactUser } from '../../forgeApi.types'

export const searchArtifactUsers = async (
  query: string
): Promise<ArtifactUser[]> => {
  const response = await forgeApi.get<unknown>('/api/v1/users/search', {
    params: { query }
  })
  const json = response.data
  const rows: unknown[] = Array.isArray(json)
    ? json
    : (((json as { data?: unknown }).data as unknown[]) ??
      ((json as { data?: { items?: unknown[] } }).data?.items as unknown[]) ??
      [])
  const out: ArtifactUser[] = []
  for (const raw of rows || []) {
    const u = (raw || {}) as Record<string, unknown>
    const id = u.id ?? u.user_id
    if (id == null) continue
    const name =
      (u.name as string) ||
      [u.f_name, u.l_name].filter(Boolean).join(' ').trim() ||
      (u.email as string) ||
      `#${id}`
    const profile = (u.profile || {}) as Record<string, unknown>
    const avatar =
      (u.avatar as string) ||
      (u.photo as string) ||
      (u.image as string) ||
      (u.profile_photo as string) ||
      (profile.avatar as string) ||
      undefined
    const user: ArtifactUser = { id: String(id), name }
    if (typeof u.email === 'string') user.email = u.email
    if (typeof avatar === 'string' && avatar) user.avatar = avatar
    out.push(user)
  }
  return out
}

export const SEARCH_ARTIFACT_USERS_QUERY_KEY = 'forge-search-users'

export const useSearchArtifactUsersQuery = (
  query: string,
  options?: ExtendableQueryOptions<ArtifactUser[]>
) =>
  useQuery({
    queryKey: [SEARCH_ARTIFACT_USERS_QUERY_KEY, query],
    queryFn: () => searchArtifactUsers(query),
    // only hit the API once there's something to search for
    enabled: query.trim().length > 0,
    ...options
  })
